import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from '@/features/auth/store/authSlice';

/**
 * Composition root for global client state.
 *
 * This lives under `app/` rather than `shared/` so that `shared/` never imports from
 * `features/`. Dependencies flow in one direction: app -> features -> shared.
 *
 * Server data (families, snapshots, audits) is cached by React Query instead of Redux;
 * only cross-cutting client state such as the session belongs here.
 */
const rootReducer = {
  auth: authReducer,
};

/**
 * Builds an isolated store. Tests use this so state cannot leak between cases; the app
 * itself uses the {@link store} singleton below.
 */
export function createAppStore() {
  return configureStore({ reducer: rootReducer });
}

export const store = createAppStore();

export type AppStore = ReturnType<typeof createAppStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
